import { useEffect, useState } from 'react'
import Gleap from 'gleap'
import { useSession } from '@emerald-works/react-auth'

const GleapInitializer = () => {
  const { isAuthenticated } = useSession()
  const [initialized, setInitialized] = useState(false)
  const isGleapEnabled = process.env.REACT_APP_GLEAP_ENABLED === 'true'

  useEffect(() => {
    if (!initialized && isAuthenticated && isGleapEnabled) {
      Gleap.initialize(process.env.REACT_APP_GLEAP_API_KEY)
      setInitialized(true)
    }
  }, [initialized, isAuthenticated, isGleapEnabled])

  return null
}

export default GleapInitializer
